<!-- <div  class="form-group row">
  <div class="col-md-12" style="white-space:nowrap">
    <button id="btnPublish" style="margin-left:0.5%;background-color:#6cd4a8;color:BLACK;FONT-WEIGHT:500;" type="submit"
      class="btn btn-grad" tabindex="0" title="Publish Project" (click)="Publishdata();" aria-label="Publish Project"
      title="Publish Project">Publish Project</button>

    <button id="btnUnPublish" type="submit"
      style="margin-left:0.5%;background-color:#efe9f2;color:BLACK;FONT-WEIGHT:500;" class="btn btn-grad" tabindex="0"
      title="UnPublish Project" (click)="UnPublishdata();" aria-label="UnPublish Project">UnPublish Project
    </button>
  </div>
</div> -->

  <!-- <div class="row ml-0 mr-0 pt-1 pl-1 mobiletext w-100 desktop-pl" [formGroup]="formControl">
    <div class="mat-column-IdInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
    </div>
    <div [ngClass]="isadmin?'mat-column-FiscalYearInput':'mat-column-FiscalYearInputE'"
      class="mat-column-FiscalYearInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-label="FiscalYear" placeholder="Fiscal Year" [(ngModel)]="FiscalYear" title="FiscalYear"
          formControlName="FiscalYear">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Fiscal Year" title="FiscalYear"
          style=" height: 32px !important;" [(ngModel)]="FiscalYear" aria-label="Search For Fiscal Year"
          formControlName="FiscalYear">
      </div>
    </div>

    <div [ngClass]="isadmin?'mat-column-ProjectNumInput':'mat-column-ProjectNumInputE'"
      class="mat-column-ProjectNumInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectNumber" placeholder="Project #" [(ngModel)]="ProjectNumber" title="Project Number"
          formControlName="ProjectNumber">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project #"
          title="Project Number" style=" height: 32px !important;" [(ngModel)]="ProjectNumber"
          aria-labelledby="Project Number" formControlName="ProjectNumber">
      </div>
    </div>

    <div [ngClass]="isadmin?'mat-column-ProjectNameInput':'mat-column-ProjectNameInputE'"
      class="mat-column-ProjectNameInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectName" placeholder="Project Name" [(ngModel)]="ProjectName" title="Project Name"
          formControlName="ProjectName">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project Name"
          title="Project Name" style=" height: 32px !important;" [(ngModel)]="ProjectName"
          aria-labelledby="Project Name" formControlName="ProjectName">
      </div>
    </div>

 

    <div [ngClass]="isadmin?'mat-column-ProjectSubCategoryInput':'mat-column-ProjectSubCategoryInputE'"
      class="mat-column-ProjectSubCategoryInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectSubcategory" placeholder="Project Category" [(ngModel)]="ProjectSubCategory"
          title="Project Category" formControlName="ProjectSubCategory">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project Category"
          title="Project Category" style=" height: 32px !important;" [(ngModel)]="ProjectSubCategory"
          aria-labelledby="Project Category" formControlName="ProjectSubCategory">
      </div>
    </div>

    <div [ngClass]="isadmin?'mat-column-ProjectStatus':'mat-column-ProjectStatusE'"
      class="mat-column-ProjectStatusInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="ProjectStatus" placeholder="Project Status" [(ngModel)]="ProjectStatus" title="ProjectStatus"
          formControlName="ProjectStatus">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 placeholder="Project Status"
          title="Project Status" style=" height: 32px !important;" [(ngModel)]="ProjectStatus"
          aria-labelledby="ProjectStatus" formControlName="ProjectStatus">
      </div>
    </div>

    <div [ngClass]="isadmin?'mat-column-CIPBudgetAmountInput':'mat-column-CIPBudgetAmountInputE'"
      class="mat-column-CIPBudgetAmountInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="Project Budget Amount" placeholder="Project Budget Amount" [(ngModel)]="CIPBudgetAmount"
          title="CIP Budget Amount" formControlName="CIPBudgetAmount">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 style=" height: 32px !important;"
          placeholder="Project Budget Amount" [(ngModel)]="CIPBudgetAmount" title="Project Budget Amount"
          aria-labelledby="Project Budget Amount" formControlName="CIPBudgetAmount">
      </div>
    </div>

  

   


    <div *ngIf="isadmin" class="mat-column-PublishedInput pr-1 mobile-pl-1" style="margin-bottom: -1rem;">
      <div class="form-group has-search">
        <span class="fa fa-search form-control-feedback" style="margin-top: -0.15rem;"></span>
        <input type="text" class="form-control mb-1 mobilesmall" tabindex=0 style=" height: 32px !important;"
          aria-labelledby="PublishedProject" placeholder="Published" [(ngModel)]="PublishedProject"
          title="PublishedProject" formControlName="PublishedProject">
        <input type="text" class="form-control mb-1 mobilelarge" tabindex=0 style=" height: 32px !important;"
          placeholder="Published" [(ngModel)]="PublishedProject" title="PublishedProject"
          aria-labelledby="PublishedProject" formControlName="PublishedProject">
      </div>
    </div>
  </div> -->

  <br>

  <div class="mat-elevation-z8">
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="communityGoal">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-CommunityGoalOne':'mat-column-CommunityGoalOne'" aria-label="Community Goal">
          <label id="CommunityGoal" aria-label="CommunityGoal">Community Goal</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-CommunityGoalOne':'mat-column-CommunityGoalOne'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Fiscal Year">Community Goal:</label></span>
          <div class="displaynormal column-overflow" title="{{element.communityGoal}} ">{{element.communityGoal}}
          </div>
          <div class="displaysmall" style="display: none;" title="{{element.communityGoal}} ">{{element.communityGoal}}
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="fundSource">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-FundSource':'mat-column-FundSource'" aria-label="Fund Source">
          <label id="FundSource" aria-label="Fund Source">Funding Source</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-FundSource':'mat-column-FundSource'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Fund Source">
            Funding Source:</label></span>
          <div class="displaynormal column-overflow" title="{{element.fundSource}} ">
            {{element.fundSource}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.fundSource}} ">
            {{element.fundSource}}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="department">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-Department':'mat-column-Department'" aria-label="Department">
          <label id="Department" aria-label="Department">Department</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-Department':'mat-column-Department'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Department">
            Department:</label></span>
          <div class="displaynormal column-overflow" title="{{element.department}} ">
            {{element.department ===  '' ? 'N/A': element.department}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.department}} ">
            {{element.department ===  '' ? 'N/A': element.department}}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="division">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-Division':'mat-column-DivisionE'" aria-label="Division">
          <label id="Division" aria-label="Division">Division</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-Division':'mat-column-DivisionE'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Division">
            Division:</label></span>
          <div class="displaynormal column-overflow" title="{{element.division}} ">
            {{element.division ===  '' ? 'N/A': element.division}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.division}} ">
            {{element.division ===  '' ? 'N/A': element.division}}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="agency">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-Entity':'mat-column-Entity'" aria-label="Entity">
          <label id="Entity" aria-label="Entity">Entity/Organization Name</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-Entity':'mat-column-Entity'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Entity">
            Entity/Organization Name:</label></span>
          <div class="displaynormal column-overflow" title="{{element.agency}} ">
            {{element.agency ===  '' ? 'N/A': element.agency}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.agency}} ">
            {{element.agency ===  '' ? 'N/A': element.agency}}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="project">
        <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0
          [ngClass]="isadmin?'mat-column-ProjectName':'mat-column-ProjectName'" aria-label="Projec tName">
          <label id="ProjectName" aria-label="ProjectName">Program/Project Name</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-ProjectName':'mat-column-ProjectName'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="ProjectName">
            Program/Project Name:</label></span>
          <div class="displaynormal column-overflow" title="{{element.project}} ">
            {{element.project}}</div>
          <div class="displaysmall" style="display: none;" title="{{element.project}} ">
            {{element.project}}</div>
        </mat-cell>
      </ng-container>


      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef  tabindex=0
          [ngClass]="isadmin?'mat-column-Amount':'mat-column-Amount'"
          aria-label="Amount">
          <label id="Amount" aria-label="Amount">Amount</label>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" tabindex="0"
          [ngClass]="isadmin?'mat-column-Amount':'mat-column-Amount'" style="width: 100%;">
          <span class="mobile-label" style="min-width: 150px"><label aria-label="Amount">
               Amount:</label></span>
          <div class="displaynormal column-overflow" style="margin-left: 38%;" title="{{element.amount}} ">
            <ng-container  *ngFor="let y of filterYear(element.yearItems)">
              {{y.amount | currency}} 
            </ng-container>
          </div>
          <div class="displaysmall" style="display: none;" title="{{element.amount}} ">
            <ng-container  *ngFor="let y of filterYear(element.yearItems)">
              {{y.amount | currency}} 
            </ng-container>
          </div>

        </mat-cell>
      </ng-container>
     
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>

    <mat-paginator [pageSizeOptions]="[10,20,50,100,500,1000]" [pageSize]="10" showFirstLastButtons></mat-paginator>
  </div>
  <div class="form-group row">
    <div class="col-md-12" style="color:crimson; text-align:center;" tabindex="0">
      <br>
      {{projectmessage}}
    </div>
  </div>

